import {RootState} from 'common/src/redux/store';
import {poll} from '../../../utils/poll';
import {Logger, PollResult} from '../../../copilot.types';

export default async function waitForNavigationCompletion({
  getState,
  isNavigationComplete,
  logger,
}: {
  getState: () => RootState;
  isNavigationComplete: (getState: () => RootState) => boolean;
  logger: Logger;
}): Promise<PollResult> {
  const result = await poll({
    checkFn: (): PollResult => {
      const isLoaded = isNavigationComplete(getState);

      if (!isLoaded) {
        return {passed: false, reason: 'Route is not loaded'};
      }

      return {passed: true};
    },
    maxAttempts: 50,
    interval: 100,
    logger,
  });

  if (!result.passed) {
    return {
      passed: false,
      reason: `Navigation initiated but route loading failed: ${result.reason}`,
    };
  }

  return {passed: true};
}
